import PropTypes from 'prop-types';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';
import './mapNugget.scss';

const MapNugget = ({ labels }) => {
  if (!labels?.mapImage) {
    return null;
  }
  return (
    <div className="gw-hotel-map-nugget">
      <CloudinaryPicture
        img={labels.mapImage.media}
        lazy
        retina
        sizes={[
          {
            width: 364,
            height: 245,
            breakpoint: 975,
          },
          {
            height: 287,
            width: 287,
            breakpoint: 768,
          },
          {
            height: 400,
            width: 747,
            breakpoint: 480,
          },
          {
            width: 459,
            height: 250,
          },
        ]}
        alt=""
      />
    </div>
  );
};

MapNugget.propTypes = {
  labels: PropTypes.shape({
    mapImage: PropTypes.shape({
      media: PropTypes.shape(),
    }),
  }).isRequired,
};

export default MapNugget;
